import React, { ReactNode } from 'react';

import { Col } from 'react-bootstrap';

type FieldViewProps = {
  name: string;
  children: ReactNode;
  style?: React.CSSProperties;
  md?: number;
  sm?: number;
  xs?: number;
  vmd?: number;
  vsm?: number;
  vxs?: number;
  className?: string;
  title?: string;
  colStyle?: React.CSSProperties;
};

export default ({
  name,
  children,
  style,
  md,
  sm,
  xs,
  vmd,
  vsm,
  vxs,
  className,
  title = '',
  colStyle,
}: FieldViewProps) => (
  <div
    className={`row field-element ${className || ''}`}
    style={style}
    title={title}
  >
    <Col className='header' md={md || 4} sm={sm || 4} xs={xs || 4}>
      {name}
    </Col>
    <Col
      className='value'
      md={vmd || 6}
      sm={vsm || 6}
      xs={vxs || 4}
      style={colStyle}
    >
      {children}
    </Col>
  </div>
);
